import { Component, DestroyRef, OnInit, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";
import { TitleService } from "@app/services/title.service";

@Component({
    selector: "app-blog-details-page",
    templateUrl: "./blog-details-page.component.html",
    styleUrls: ["./blog-details-page.component.scss"],
})
export class BlogDetailsPageComponent implements OnInit {
    pageData = "";
    private destroyRef = inject(DestroyRef);
    constructor(
        private route: ActivatedRoute,
        private titleService: TitleService,
    ) {}

    ngOnInit(): void {
        this.route.data
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data) => {
                switch (data.kind) {
                    case "what-is-CoP": {
                        this.pageData = "what-is-CoP";
                        this.pageTitleArea = [
                            {
                                title: "Community of Practice",
                                subTitle: "What is Community of Practice",
                            },
                        ];
                        break;
                    }
                    case "CoP-Newsletter1": {
                        this.pageData = "CoP-Newsletter1";
                        this.pageTitleArea = [
                            {
                                title: "Community of Practice",
                                subTitle:
                                    "New Dashboard tracks key metrics about Upstream Data Products",
                            },
                        ];
                        break;
                    }
                    case "CoP-Newsletter2": {
                        this.pageData = "CoP-Newsletter2";
                        this.pageTitleArea = [
                            {
                                title: "Community of Practice",
                                subTitle:
                                    "New workflow tool makes proposing new Upstream business glossary terms easy",
                            },
                        ];
                        break;
                    }
                    case "CoP-Newsletter3": {
                        this.pageData = "CoP-Newsletter3";
                        this.pageTitleArea = [
                            {
                                title: "Community of Practice",
                                subTitle:
                                    "Conceptual Data Model Dashboard is released",
                            },
                        ];
                        break;
                    }
                    case "UDF-CoP": {
                        this.pageData = "UDF-CoP";
                        this.pageTitleArea = [
                            {
                                title: "Community of Practice",
                                subTitle: "UDF - Community of Practice",
                            },
                        ];
                        break;
                    }
                    case "benefits-CoP": {
                        this.pageData = "benefits-CoP";
                        this.pageTitleArea = [
                            {
                                title: "Community of Practice",
                                subTitle: "Benefits of Communities of Practice",
                            },
                        ];
                        break;
                    }
                    case "CoP-Roles": {
                        this.pageData = "CoP-Roles";
                        this.pageTitleArea = [
                            {
                                title: "Community of Practice",
                                subTitle:
                                    "Community of Practice Roles and Responsibilities",
                            },
                        ];
                        break;
                    }
                    case "default": {
                        this.pageTitleArea = [
                            {
                                title: "Blog Details",
                                subTitle: "",
                            },
                        ];
                        break;
                    }
                }
            });

        this.titleService.setTitle("CoP");
    }
    pageTitleArea: pageTitle[] = [
        {
            title: "Blog Details",
            subTitle: "",
        },
    ];
}
class pageTitle {
    title: string;
    subTitle: string;
}
